import React, { useState } from 'react';
import { useAdmin } from '../context/AdminContext';
import './AdminGate.css';

export default function AdminGate({ children }) {
  const { isUnlocked, unlock } = useAdmin();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    if (unlock(password)) {
      setPassword('');
    } else {
      setError('Incorrect password.');
    }
  };

  if (isUnlocked) {
    return children;
  }

  return (
    <div className="admin-gate">
      <div className="admin-gate-box">
        <h3>Admin access required</h3>
        <p>You need admin access to view this section. Enter the password.</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoComplete="current-password"
          />
          <button type="submit">Enter</button>
        </form>
        {error && <p className="admin-gate-error">{error}</p>}
      </div>
    </div>
  );
}
